<mat-form-field class="datepicker">
  <mat-label>{{label}}</mat-label>
  <input (dateChange)=onDateChanged($event.value) [matDatepicker]="picker" matInput>
  <mat-datepicker-toggle [for]="picker" matIconSuffix></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
